import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/:operator/:id(\\d+)/home',
    name: 'home',
    component: () => lazyLoadView(import('@views/admin/home/Index')),
    meta: {
      title: 'Beranda',
    },
  },
  // {
  //   path: '/:operator/:id(\\d+)/*',
  //   redirect: { name: 'home' },
  // },
];
